/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EntitlementSummaryDto
 */
export interface EntitlementSummaryDto {
    /**
     * Entitlement ID
     * @type {string}
     * @memberof EntitlementSummaryDto
     */
    'id': string;
    /**
     * Entitlement name
     * @type {string}
     * @memberof EntitlementSummaryDto
     */
    'name': string;
    /**
     * Entitlement type
     * @type {string}
     * @memberof EntitlementSummaryDto
     */
    'type': EntitlementSummaryDtoTypeEnum;
    /**
     * Total quantity needed for this event
     * @type {number}
     * @memberof EntitlementSummaryDto
     */
    'total': number;
    /**
     * Quantity to be prepared (on standby)
     * @type {number}
     * @memberof EntitlementSummaryDto
     */
    'toPrepare': number;
    /**
     * Quantity prepared (shipping soon)
     * @type {number}
     * @memberof EntitlementSummaryDto
     */
    'prepared': number;
    /**
     * Quantity shipped (out for delivery)
     * @type {number}
     * @memberof EntitlementSummaryDto
     */
    'shipped': number;
    /**
     * Quantity delivered
     * @type {number}
     * @memberof EntitlementSummaryDto
     */
    'delivered': number;
}

export const EntitlementSummaryDtoTypeEnum = {
    Physical: 'physical',
    Digital: 'digital'
} as const;

export type EntitlementSummaryDtoTypeEnum = typeof EntitlementSummaryDtoTypeEnum[keyof typeof EntitlementSummaryDtoTypeEnum];


